import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-framework',
  templateUrl: './ui-framework.component.html',
  styleUrls: ['./ui-framework.component.sass']
})
export class UIFrameworkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
